<template>
  <div class="relative">
    <label class="mb-1 block text-xs font-semibold text-gray-800">{{
      $t(`mygwf.components.Label.companies`)
    }}</label>
    <BaseIcon
      v-if="filterArray.length > 0"
      icon="close"
      @click="filterArray.splice(0, filterArray.length)"
      class="cursor-pointer absolute right-0 top-0 hover:text-primary"
    />
    <div
      :class="[
        'flex justify-between border-gray-200 border mb-3  bg-secondary-light',
        filterArray.length === 0 ? 'h-8' : 'items-start pl-1',
      ]"
      @click="inputClick"
    >
      <div class="flex flex-nowrap">
        <div v-if="filterArray.length > 0" class="flex flex-wrap">
          <span
            class="bg-primary-light px-1 py-1 flex items-center justify-between mr-2 my-1 text-white text-xs cursor-default"
            v-for="(item, index) in filterArray"
            @click="filterArray.splice(index, 1)"
            :key="index"
          >
            <span class="pl-1">{{ showCompanyName(item) }}</span>
            <BaseIcon class="ml-2" icon="close" />
          </span>
        </div>
      </div>
      <a-popover v-model="visible" placement="bottomLeft" trigger="click" arrowPointAtCenter>
        <span slot="title" class="flex justify-end">
          <a class="cursor-pointer text-sm" slot="content" @click="visible = false">{{
            $t(`mygwf.components.ButtonIcon.close`)
          }}</a>
        </span>
        <template #content>
          <ListSelect
            :options="$store.getters['companies/list']"
            class="w-full text-sm"
            v-model="filterArray"
            clearable
          />
        </template>
        <base-button-icon icon="search" id="popover-button" size="sm" />
      </a-popover>
    </div>
  </div>
</template>

<script>
import {BaseIcon, BaseButtonIcon} from '@/components/base'
import ListSelect from '@/components/shared/ListSelect.vue'
import Popover from 'ant-design-vue/lib/popover'
import 'ant-design-vue/lib/popover/style/index.css'
import {selectStyle} from '@/state/helpers/mixins.js'

export default {
  mixins: [selectStyle],
  props: {
    filterArray: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  components: {
    BaseIcon,
    BaseButtonIcon,
    ListSelect,
    'a-popover': Popover,
  },
  methods: {
    showCompanyName(value) {
      const index = this.$store.getters['companies/list'].findIndex(row => +row['id'] === +value)
      return index > -1 ? this.$store.getters['companies/list'][index]['name'] : ''
    },
    inputClick() {
      if (this.filterArray.length > 0) {
        return
      }
      this.visible = true
    },
  },
}
</script>

<style></style>
